import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./page/Home";
import Host from "./page/Host";
import Prepare from "./page/Prepare";
import Await from "./page/Await";
import Backstage from "./page/Backstage";
import Photos from "./page/Backstage/Photos";
import ConfirmComponent from "./components/confirm/confirm";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* 主持端 */}
        <Route path="/host" element={<Host />} />
        {/* 设置名称页面 */}
        <Route path="/prepare" element={<Prepare />} />
        {/* 等待进入页面 */}
        <Route path="/await" element={<Await />} />
        {/* 后台页面 */}
        <Route path="/backstage" element={<Backstage />} />
        {/* 照片页面 */}
        <Route path="/photos" element={<Photos />} />
      </Routes>
      <ConfirmComponent />
    </BrowserRouter>
  );
}

export default App;
